import format from 'date-fns/format'
import React from 'react'
import { EntityHeader, HeaderColumnConfig } from '../shared'
import { renderColorByString } from './renderColorByString'

function formatDate(timestamp: any) {
  if (!timestamp) return '—'
  return format(new Date(timestamp), 'MM/dd/yyyy')
}

interface BoardsGridHeaderProps {
  newDeal: any
  organization: any
}

const BoardsGridHeader: React.FC<BoardsGridHeaderProps> = ({ newDeal, organization }) => {
  const columns: HeaderColumnConfig[] = [
    {
      key: 'dates',
      fields: [
        { label: 'Est Launch Date', value: newDeal?.estLaunchDate, format: formatDate },
        { label: 'Start Date', value: newDeal?.startDate, format: formatDate },
        { label: 'End Date', value: newDeal?.endDate, format: formatDate },
      ],
    },
    {
      key: 'status',
      fields: [
        {
          label: 'Onboarding Status',
          value: newDeal?.onboardingStatus ?? 'On Hold',
          getColor: renderColorByString,
        },
        {
          label: 'Contract Status',
          value: newDeal?.status || 'no nco status',
          getColor: renderColorByString,
        },
        {
          label: 'Deal Status',
          value: newDeal?.dealStatus || 'no nco status',
          getColor: renderColorByString,
        },
      ],
    },
    {
      key: 'organization',
      fields: [
        {
          label: 'Organization Status',
          value: organization?.status,
          getColor: renderColorByString,
        },
        {
          label: 'Website',
          value: organization?.website,
          truncate: true,
          fontSize: 12,
        },
        {
          label: 'Type',
          value: newDeal?.type,
          getColor: renderColorByString,
        },
      ],
    },
  ]

  return <EntityHeader columns={columns} />
}

export default BoardsGridHeader
